import { APP_URL, DRAWER_WIDTH, VERSION } from "../config";
import React, { useEffect, useState } from "react";

import AppBar from "./AppBar";
import { Layout as FobLayout } from "ra-friendsofbabba";
import Menu from "./Menu";
import logo from "../assets/logo.png";

const appVersion = VERSION.replace("{BITBUCKET_BUILD_NUMBER}", "0");

const Layout = (props) => {
  const [apiVersion, setApiVersion] = useState(null);

  useEffect(() => {
    fetch(`${APP_URL}version.json`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((r) => r.json())
      .then(({ apiVersion }) =>
        setApiVersion(apiVersion.replace("{BITBUCKET_BUILD_NUMBER}", "0-dev"))
      )
      .catch(() => setApiVersion("0.0.0"));
  }, []);
  return (
    <FobLayout
      {...props}
      logo={<img src={logo} alt="SXS" width="84" style={{ marginTop: 16 }} />}
      title={null}
      subTitle={`${appVersion} - api-${apiVersion}`}
      drawerWidth={DRAWER_WIDTH}
      menu={Menu}
      appBar={AppBar}
    />
  );
};
export default Layout;
